import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  UpdateFraudMonitoringBody,
  updateFraudMonitoring,
  AccountHolder,
} from "../../../services/accountService";
import useCreateAccountHolderNotesMutation from "./useCreateAccountHolderNotesMutation";

export default function useUpdateFraudMonitoringMutation(
  accountHolderCode: string
) {
  const queryClient = useQueryClient();
  const { mutateAsync: createNote } = useCreateAccountHolderNotesMutation();

  return useMutation<string, Error, UpdateFraudMonitoringBody>(
    (body) => updateFraudMonitoring(body),
    {
      async onSuccess(_, updatedFraudMonitoring) {
        const accountConfigData = queryClient.getQueryData<AccountHolder>([
          "accountConfig",
          accountHolderCode,
        ]);

        if (!accountConfigData) return;

        queryClient.setQueryData(["accountConfig", accountHolderCode], {
          ...accountConfigData,
          fraudMonitoring: updatedFraudMonitoring.fraudMonitoring,
        });

        await createNote({
          accountHolderCode,
          noteContent: [
            {
              fieldName: "Monitoring Status",
              fromValue: accountConfigData.fraudMonitoring ? "On" : "Off",
              toValue: updatedFraudMonitoring.fraudMonitoring ? "On" : "Off",
            },
          ],
        });

        queryClient.invalidateQueries(["accountConfig", accountHolderCode]);
      },
    }
  );
}
